var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-icon"},[(_vm.model && _vm.model.avatar)?_c('img',{staticClass:"single-user-icon p-0",attrs:{"src":_vm.model.avatar}}):_c('div',{staticClass:"single-user-icon"},[_c('div',{staticClass:"mask"})])])}
var staticRenderFns = []

export { render, staticRenderFns }